export const PlusIcon = (props) => (
  <svg fill={props.color} height={`${props.size || 39}`} width={`${props.size || 39}`} viewBox="0 0 24 24">
    <g>
      <path stroke={props.color} strokeWidth={2} d="M12 5.5v13" />
      <path stroke={props.color} strokeWidth={2} d="M18.5 12h-13" />
    </g>
  </svg>
);
